import { render, staticRenderFns } from "./ShowTask.vue?vue&type=template&id=506ade17&scoped=true"
import script from "./ShowTask.vue?vue&type=script&lang=js"
export * from "./ShowTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ade17",
  null
  
)

export default component.exports